import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { CreatePoaSchema, UpdatePoaSchema } from '@app/models/users';
import Api from '@app/services/api';

import { IPoaTarget } from '../components/Poas/interfaces';

export const usePoasQuery = (target: IPoaTarget, enabled: boolean) =>
  useQuery({
    queryKey: ['poas', target.kind, target.uid],
    queryFn: () =>
      target.kind === 'legalEntity' ? Api.users.getLegalEntityPoas(target.uid) : Api.users.getCoalitionPoas(target.uid),
    enabled,
    retry: false,
  });

export const useCreatePoaMutation = (target: IPoaTarget) => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (data: CreatePoaSchema) =>
      target.kind === 'legalEntity'
        ? Api.users.postLegalEntityPoa(target.uid, data)
        : Api.users.postCoalitionPoa(target.uid, data),
    onSettled: () => client.invalidateQueries(['poas']),
  });
};

export const useUpdatePoaMutation = (target: IPoaTarget) => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ uid, data }: { uid: string; data: UpdatePoaSchema }) =>
      target.kind === 'legalEntity'
        ? Api.users.patchLegalEntityPoa(target.uid, uid, data)
        : Api.users.patchCoalitionPoa(target.uid, uid, data),
    onSettled: () => client.invalidateQueries(['poas']),
  });
};
